import { Location } from './location.model';
import { Claus } from './claus.model';

export class Risk {
    location: Location;
    riskCategory: any;
    riskQuantity: number;
    coverageType: any;
    clauses: Claus[];

    constructor() {
        this.location = new Location();
        this.riskCategory = null;
        this.riskQuantity = null;
        this.coverageType = null;
        this.clauses = [];
    }
}
